import { render, staticRenderFns } from "./xiangao.vue?vue&type=template&id=aa4d2546"
import script from "./xiangao.vue?vue&type=script&lang=ts"
export * from "./xiangao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports